"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _axios = _interopRequireDefault(require("axios"));

var _reactToastify = require("react-toastify");

var _formik = require("formik");

var _schema = _interopRequireDefault(require("./schema"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _defaultTranslations = require("./defaultTranslations");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ChangePassword = function ChangePassword(_ref) {
  var translations = _ref.translations,
      onError = _ref.onError,
      onSuccess = _ref.onSuccess,
      onBackClicked = _ref.onBackClicked,
      hideBackButton = _ref.hideBackButton;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      serverError = _useState2[0],
      setServerError = _useState2[1];

  if (!translations) {
    translations = _defaultTranslations.defaultTranslations;
  }

  var validate = function validate(values) {
    var errors = {};

    if (!/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*/.test(values.newPassword)) {
      errors.newPassword = translations.changePasswordValidation;
    }

    if (values.newPassword !== values.newPasswordConfirm) {
      errors.newPasswordConfirm = translations.passwordsDoNotMatch;
    }

    return errors;
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(values, _ref2) {
      var setSubmitting, params, res, _response$data, _response$data$errors, response;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setSubmitting = _ref2.setSubmitting;
              params = {
                new: values.newPassword,
                old: values.oldPassword
              };
              _context.prev = 2;
              _context.next = 5;
              return _axios.default.put("/auth/password", params);

            case 5:
              res = _context.sent;
              onSuccess();
              _context.next = 14;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              response = _context.t0.response;

              if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && (_response$data$errors = _response$data.errors) !== null && _response$data$errors !== void 0 && _response$data$errors.old) {
                setServerError("".concat(translations.old, " ").concat(translations.password, " ").concat(translations.wrong));
              }

              onError(response);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 9]]);
    }));

    return function onSubmit(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Card, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Alert, {
    margin: "0 0 1rem"
  }, translations.oldPasswordWarning), /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    onSubmit: onSubmit,
    initialValues: {
      oldPassword: "",
      newPassword: "",
      newPasswordConfirm: ""
    },
    validate: validate,
    validationSchema: (0, _schema.default)(translations)
  }, function (_ref5) {
    var isValid = _ref5.isValid,
        isSubmitting = _ref5.isSubmitting,
        values = _ref5.values,
        errors = _ref5.errors,
        dirty = _ref5.dirty,
        touched = _ref5.touched,
        handleChange = _ref5.handleChange;
    return /*#__PURE__*/_react.default.createElement(_formik.Form, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
      isError: values.oldPassword !== "" && errors.oldPassword,
      type: "password",
      name: "oldPassword",
      placeholder: "Enter your old password",
      onChange: handleChange,
      value: values.oldPassword
    })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
      isVisible: values.oldPassword !== "" && errors.oldPassword
    }, errors.oldPassword), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
      onChange: handleChange,
      name: "newPassword",
      type: "password",
      placeholder: "Enter New Password",
      value: values.newPassword
    })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
      isVisible: values.newPassword !== "" && errors.newPassword
    }, errors.newPassword), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, {
      isSmall: true
    }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
      isError: values.newPasswordConfirm !== "" && errors.newPasswordConfirm,
      onChange: handleChange,
      name: "newPasswordConfirm",
      type: "password",
      placeholder: "Confirm New Password",
      value: values.newPasswordConfirm
    })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
      margin: "0 0 1rem",
      isVisible: values.newPasswordConfirm !== "" && errors.newPasswordConfirm
    }, errors.newPasswordConfirm), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
      margin: "0 0 1rem",
      isVisible: isValid && serverError
    }, serverError), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
      disabled: !isValid || !dirty,
      isLoading: isSubmitting
    }, translations.change, " ", translations.password), !hideBackButton && /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
      style: {
        marginTop: "1rem"
      },
      isDefault: true,
      type: "button",
      onClick: onBackClicked
    }, translations.back));
  }));
};

var _default = ChangePassword;
exports.default = _default;